export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1640_.6a817b24.jpg";